import React from "react";

const ScheduleModal = ({
  saving,
  nextRoundSchedule,
  setNextRoundSchedule,
  onClose,
  onConfirm,
}) => (
  <div
    className="modal-backdrop"
    role="dialog"
    aria-modal="true"
    onClick={() => {
      if (!saving) {
        onClose();
      }
    }}
  >
    <div className="modal" onClick={(event) => event.stopPropagation()}>
      <div className="modal-header">
        <div>
          <h3>Schedule next round</h3>
          <div className="helper-text">Set the start/end time for the next round.</div>
        </div>
        <button
          className="button ghost small"
          type="button"
          onClick={onClose}
          disabled={saving}
        >
          Close
        </button>
      </div>
      <div className="modal-body">
        <label className="field">
          <span>Scheduled start</span>
          <input
            type="datetime-local"
            value={nextRoundSchedule.start}
            onChange={(event) =>
              setNextRoundSchedule((prev) => ({
                ...prev,
                start: event.target.value,
              }))
            }
          />
        </label>
        <label className="field">
          <span>Scheduled end</span>
          <input
            type="datetime-local"
            value={nextRoundSchedule.end}
            onChange={(event) =>
              setNextRoundSchedule((prev) => ({
                ...prev,
                end: event.target.value,
              }))
            }
          />
        </label>
        <div className="helper-text">Leave blank to keep the schedule as TBD.</div>
      </div>
      <div className="modal-actions">
        <button
          className="button ghost"
          type="button"
          onClick={onClose}
          disabled={saving}
        >
          Cancel
        </button>
        <button
          className="button primary"
          type="button"
          onClick={onConfirm}
          disabled={saving}
        >
          {saving ? "Creating..." : "Create round"}
        </button>
      </div>
    </div>
  </div>
);

export default ScheduleModal;
